import { useContext, useEffect, useState } from "react"
import { LineLoader } from "@components"
import { ContextualSidebarContext } from "@context";
import { GET_EVENT } from "@graphql"
import { useQuery } from "@apollo/client"
import { Button } from "@heroui/react"
import { ChevronLeftIcon } from "@heroicons/react/24/outline"

import { 
  DeleteEvent, 
  EventAccess, 
  EventBasicInfo, 
  EventSettings, 
  ImpersonateUser,
  EventMeetingTypes,
  MetaDetails,
  SessionRouter,
} from "../Sections"

import EventItems from "../EventItems"
import { VIEWS } from "../data"
import PropTypes from "prop-types"

const MenuRouter = ({ eventId, user, initialView = "MENU" }) => {
  const [view, setView] = useState(VIEWS[initialView])
  const { setContextualSidebar } = useContext(ContextualSidebarContext);

  /** 
   * Refresh event from the cache to avoid stale data as contextual 
   * sidebar event prop won't update when updates are made from the menu
   * */
  const { data, loading } = useQuery(GET_EVENT, {
    variables: { event_id: eventId },
    fetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    setContextualSidebar(prev => ({ ...prev, title: view.title, subTitle: view.subTitle }));
  }, [view, setContextualSidebar]);

  const backButton = (
    <Button className="mt-2" onPress={() => setView(VIEWS.MENU)} fullWidth>
      <ChevronLeftIcon className="w-4 h-4 mr-2" />
      Back to Menu
    </Button>
  )

  if (loading) {
    return <LineLoader message="Please wait loading..." classNames="mt-8" />
  }

  const event = data?.event || {}
  const allowManualSbAccountMatching = user?.me?.client?.settings?.allow_manual_sb_account_matching || false

  return (
    <div>
      {view.key === "MENU" && <EventItems handleMenuSelect={(id) => setView(id)} />}
      {view.key === "IMPERSONATE" && <ImpersonateUser event={event} backButton={backButton} />}
      {view.key === "DELETE" && <DeleteEvent event={event} backButton={backButton} />}
      {view.key === "ACCESS" && <EventAccess event={event} backButton={backButton} allowManualSbAccountMatching={allowManualSbAccountMatching} />}
      {view.key === "BASIC_INFO" && <EventBasicInfo event={event} backButton={backButton} />}
      {view.key === "SETTINGS" && <EventSettings event={event} backButton={backButton} />}
      {view.key === "SESSIONS" && <SessionRouter event={event} backButton={backButton} />}
      {view.key === "MEETING_TYPES" && <EventMeetingTypes event={event} backButton={backButton} />}
      {view.key === "META" && <MetaDetails event={event} backButton={backButton} />}
    </div>
  )
}

MenuRouter.propTypes = {
  eventId: PropTypes.string.isRequired,
  initialView: PropTypes.string,
}

export default MenuRouter